"use client";

import { X, ArrowLeft } from "lucide-react";

import { Button } from "./ui/button";
import { Skeleton } from "./ui/skeleton";
import { useAuth } from "../context/AuthContext";
import {
  useInvestPortfolio,
  useQueryDigitalWallet,
  useQueryUserBalance,
  useQueryUserProfile,
} from "../hooks/query/queries";
import { toast } from "../hooks/use-toast";
import infoIcon from "../assets/icons/info_white.svg";
import settings from "../assets/icons/settings-invest.svg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CurrencyFormatter from "../utils/currencyFormatter";
import HowToInvest from "./HowToInvest";

export function InvestSummary({ dashType, product, appProduct, userId }) {
  const navigate = useNavigate();
  const [howItWorks, setHowItWorks] = useState(true);
  const [open, setOpen] = useState(false);
  const { data: portfolioEstimate, isLoading: loadingEst } =
    useInvestPortfolio(userId);

  // useEffect(() => {
  //   const retrieveWallet = async () => {
  //     const walletBalance = await getWalletBalances();

  //     setWallet(walletBalance.data.data);
  //     setAssetBalance(walletBalance.data.data.assetBalance);

  //   };
  //   retrieveWallet();
  // }, []);

  const { user } = useAuth();
  const authId = user?.sub || "";

  const { isLoading: loading, error } = useQueryUserBalance(authId);

  useQueryDigitalWallet(authId);
  useQueryUserProfile();

  function hideShowHelp() {
    setHowItWorks(!howItWorks);
  }

  useEffect(() => {
    if (error) {
      toast({
        description: `${error}`,
        variant: "eighty",
      });
    }
  }, [error, loading]);
  const formatter = new CurrencyFormatter();
  return (
    <div>
      <div className="px-14 py-8 text-white">
        <div className="mb-6">
          <div className="text-sm opacity-90">Investment portfolio value</div>
          <div className="flex items-center space-x-2">
            {loadingEst ? (
              <div className="text-5xl font-bold">
                <Skeleton className="w-64 h-12 rounded-full bg-accent/30" />
              </div>
            ) : (
              <div className="text-5xl font-bold">
                {formatter.format(portfolioEstimate?.portfolioEstimate, "ZAR")}
              </div>
            )}
            <Button
              variant="outline"
              className="rounded-[70px] bg-transparent border-secondary/50 hover:bg-background/30 p-[10px] h-9"
              onClick={() => navigate("/settings/invest")}
            >
              <img
                src={settings}
                alt=""
                className="max-h-[15px] max-w-[15px]"
              />
            </Button>
          </div>
        </div>
      </div>
      {howItWorks && (
        <div
          className={
            "rounded-t-lg min-h-14 bg-gradient-to-l from-accent-blue to-brand-secondary border border-white/30"
          }
        >
          {dashType === "invest" ? (
            <div className="flex flex-row items-center p-2">
              <div className="flex flex-1 flex-row justify-center text-white py-2 mb-4">
                <img src={infoIcon} alt="" className="" />
                <Link
                  href={"#"}
                  className="underline ml-2 font-medium truncate text-[#FFFFFF] text-[16px]"
                  onClick={() => setOpen(true)}
                >
                  How does this work?
                </Link>
              </div>
              <HowToInvest
                open={open}
                setOpen={setOpen}
                // setActiveTab={setActiveTab}
              />
              <Button
                className="rounded-full bg-transparent border h-6 w-6 p-4 mb-4 hover:bg-background/30"
                onClick={() => hideShowHelp()}
              >
                <X strokeWidth={1} size={48} />
              </Button>
            </div>
          ) : (
            <div className="flex flex-row items-center p-1 px-14">
              <div className="flex flex-1 flex-row justify-begin items-center py-2 mb-4">
                <Button
                  className="rounded-full bg-transparent border h-6 w-6 p-4 mr-2  hover:bg-background/30"
                  onClick={() => navigate("/invest")}
                >
                  <ArrowLeft strokeWidth={1} size={48} />
                </Button>
                <p className="text-white mr-2">Invest</p>
                <p className="text-white mr-2 "> / </p>
                <p className="text-white"> {product || appProduct}</p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
